<div class="select" [ngClass]="{ 'select--active': value !== undefined && value !== null && value !== '' && label, 'select--error': error }">
  <div class="select__wrap">
    @if (label) {
      <label class="select__label" [for]="id">
        {{ label }}
        @if (required) {
          <span class="select__label-required">*</span>
        }
      </label>
    }
    <div class="select__main">
      <select class="select__content select__content--{{ size }} select__content--align-{{ align }}" [ngClass]="{ 'select__content--default': !value }" [(ngModel)]="value" [attr.id]="id" [required]="required" [attr.name]="name" (change)="change()" (focusout)="touch()">
        @if (items && loaded) {
          @for (item of items; track $index) {
            <option class="select__option" [value]="item.value" [hidden]="item.hidden">{{ item.content }}</option>
          }
        }
      </select>
      <ng-content></ng-content>
      @if (arrow && !icon) {
        <app-icon class="select__anchor" [icon]="'chevron-bold'" [width]="16" [rotate]="90"></app-icon>
      } @else {
        <app-icon class="select__icon" [icon]="icon" [width]="24"></app-icon>
      }
    </div>
  </div>
  @if (error) {
    <app-input-error class="select__error">
      {{ errorMessage }}
    </app-input-error>
  }
</div>
